import {
  DynamicConditionDataCreateRequest,
  DynamicConditionDataCreateResponse,
} from '../../types/DynamicCondition.types';
import ApiClient, { IApiClient } from '../ApiClient';

interface IDynamicConditionApiClient {
  create(data: DynamicConditionDataCreateRequest): Promise<DynamicConditionDataCreateResponse | undefined>;
  update(data: DynamicConditionDataCreateRequest): Promise<DynamicConditionDataCreateResponse | undefined>;
}

export class DynamicConditionApiClient implements IDynamicConditionApiClient {
  variableApiClient: IApiClient;

  constructor(DynamicConditionApiClient: IApiClient) {
    this.variableApiClient = DynamicConditionApiClient;
  }

  async create(data: DynamicConditionDataCreateRequest): Promise<DynamicConditionDataCreateResponse | undefined> {
    // return undefined;

    const response = await this.variableApiClient.post<
      DynamicConditionDataCreateRequest,
      DynamicConditionDataCreateResponse
    >(`/condicioes-inteligentes`, data);
    return response;
  }

  async update(data: DynamicConditionDataCreateRequest): Promise<DynamicConditionDataCreateResponse | undefined> {
    // return undefined;

    const response = await this.variableApiClient.put<
      DynamicConditionDataCreateRequest,
      DynamicConditionDataCreateResponse
    >(`/condicioes-inteligentes`, data);
    return response;
  }
}

export default class DynamicConditionService {
  variableApiClient: IDynamicConditionApiClient;

  constructor() {
    this.variableApiClient = new DynamicConditionApiClient(new ApiClient());
  }

  async create(data: DynamicConditionDataCreateRequest): Promise<DynamicConditionDataCreateResponse | undefined> {
    return this.variableApiClient.create(data);
  }

  async update(data: DynamicConditionDataCreateRequest): Promise<DynamicConditionDataCreateResponse | undefined> {
    return this.variableApiClient.update(data);
  }
}
